import type { Schemas } from '#shopware'
import { useAddToCart as swUseAddToCart, type UseAddToCartReturn } from "@shopware/composables";
import { useCart } from "#imports";
import { ref, unref, type Ref, computed } from 'vue'

export type CustomUseAddToCartReturn = Omit<UseAddToCartReturn, 'addToCart'> & {
  /**
   * Add to cart method
   * @type {function}
   */
  addToCart(payload?: Schemas['AddToCartPayload']): Promise<Schemas["Cart"]>;
};

function customUseAddToCart (product: Ref<Schemas["Product"] | undefined>): CustomUseAddToCartReturn {
    const { ...coreUseAddToCart } = swUseAddToCart(product)
    const _product = computed(() => unref(product));

    const { addProduct } = useCart();
    const quantity: Ref<number> = ref(1);

    async function addToCart(payload?: Schemas['AddToCartPayload']): Promise<Schemas["Cart"]> {
        if (!_product.value?.id) throw new Error("Product id is required");

        const addToCartResponse = await addProduct({
            id: _product.value?.id,
            quantity: quantity.value,
            ...(payload && { payload })
        });
        quantity.value = 1;
        return addToCartResponse;
    }

    return {
        ...coreUseAddToCart,
        addToCart,
        quantity
    }
}

export const useAddToCart = customUseAddToCart;